<template>
  <pbc-modal title='Add Collisions' @close="$emit('close')" @done='done' >
    <choose-transforms :transforms-and-sources='transformsAndSources' :selections='selections' :initialize-empty='true' />
  </pbc-modal>
</template>
<script>
import { fromPairs, toPairs } from 'lodash';
import ChooseTransforms from '@ui/molecules/ChooseTransforms.vue';
export default {
  props: {
    transformsAndSources: {
      type: Array,
      required: true
    }
  },
  data() {
    const selections = {};
    return {
      selections
    }
  },
  components: {
    ChooseTransforms
  },
  methods: {
    done() {
      const components = toPairs(this.selections)
        .filter( ([cid,value]) => {
          return value;
        })
        .map( ([cid,value]) => {
          return cid;
        });
      this.$emit("done", components);

    }
  }
}
</script>
